import apiSlice from "./ApiSlice";

export const QuestionTechnologyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL QuestionTechnology WITH PAGINATION
    getAllQuestionTechnologyWithPagination: builder.query({
      providesTags: ["question-technology"],
      query: (body) => {
        return {
          url: "/question-technology",
          method: "POST",
          body,
        };
      },
    }),
    // GET ALL QuestionTechnology 

    getAllQuestionTechnology: builder.query({
      providesTags: ["question-technology"],
      query: () => {
        return {
          url: "/question-technology",
          method: "GET",
        };
      },
    }),
    // Add
    addQuestionTechnology: builder.mutation({
      invalidatesTags: ["question-technology"],
      query: (body) => {
        return {
          url: "/question-technology/add",
          method: "POST",
          body,
        };
      },
    }),
    // DELETE
    deleteQuestionTechnology: builder.mutation({
      invalidatesTags: ["question-technology"],
      query: ({ id }) => {
        return {
          url: `/question-technology/${id}`,
          method: "DELETE",
        };
      },
    }),
    // GET QuestionTechnology BY ID
    getQuestionTechnologyById: builder.query({
      providesTags: ["question-technology"],
      query: ({ id }) => {
        return {
          url: `/question-technology/${id}`,
          method: "GET",
        };
      },
    }),
    // EDIT
    editQuestionTechnology: builder.mutation({
      invalidatesTags: ["question-technology"],
      query: ({ body, id }) => {
        return {
          url: `/question-technology/${id}`,
          method: "PUT",
          body,
        };
      },
    }),


  }),
});

export const {
  useGetAllQuestionTechnologyWithPaginationQuery,
  useAddQuestionTechnologyMutation,
  useDeleteQuestionTechnologyMutation,
  useEditQuestionTechnologyMutation,
  useGetQuestionTechnologyByIdQuery,
  useGetAllQuestionTechnologyQuery
} = QuestionTechnologyApi;
